import React, { useState } from 'react';
import Modal from '../../../../shared/modal';
import { DOCUMENT_TABS } from '../../../../utils/constants/documents-tabs';
import DocumentsTable from '../tables/DocumentsTable';


interface IDocumentsModal {
    openModal: boolean;
    tabOpened?: any;
    handleCloseModal: () => void;
}

const DocumentsModal = ({
    openModal,
    tabOpened,
    handleCloseModal,
}: IDocumentsModal) => {
    const [activeTab, setActiveTab] = useState<any>(tabOpened || DOCUMENT_TABS?.[0])

    const onChangeActiveTab = (tab: any) => {
        setActiveTab(tab)
    }

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'}>
            <div className={'p-2 max-w-[98vw] min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px] '}>
                <div className='flex flex-row justify-between items-center'>
                    <p className='mb-2 font-semibold text-sm dark:text-primary-dark'>Sofia - Most questioned documents</p>
                </div>
                <div className='flex flex-row my-1 items-center'>
                    {DOCUMENT_TABS?.map((item: any, idx: number) => {
                        return (
                            <div
                                key={idx}
                                onClick={() => onChangeActiveTab(item)}
                                className={`cursor-pointer hover:opacity-80 ${activeTab?.value === item?.value ? 'text-[#1E4380] dark:text-primary-dark' : 'text-[#a4a4a4]'} mr-5 font-semibold`}>
                                <p>{item?.label}</p>
                            </div>
                        )
                    })}
                </div>
                <DocumentsTable
                    activeTab={activeTab}
                />
            </div>
        </Modal >
    )
}
export default DocumentsModal;